const r = Object.freeze({
  // There is no method to both specify that the values of an object should be of a specific type, and also to specify
  // that object as a const assertion for greatly improved type suggestions. I've opted for improved type suggestions
  // over succinct value typing by specifying as Range manually.
  XS: { min: Number.NEGATIVE_INFINITY, max: 319 },
  SM: { min: 320, max: 767 },
  MD: { min: 768, max: 990 },
  LG: { min: 991, max: 1190 },
  XL: { min: 1191, max: Number.POSITIVE_INFINITY }
});
var e = /* @__PURE__ */ ((m) => (m.SMALLER = "smaller", m.LARGER = "larger", m))(e || {});
export {
  r as BREAKPOINTS,
  e as DIRECTION
};
//# sourceMappingURL=breakpoints.js.map
